<template>
  <div>
    <CustomDialog
      :show="show"
      :title="
        Object.keys(rowInfo).length ? $t('public.editBS') : $t('public.addBS')
      "
      @toggleShow="handleClose"
      :appendToBody="true"
      width="400"
    >
      <div slot="main">
        <div class="info">
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
            size="small"
          >
            <el-form-item :label="$t('public.bsName')" prop="name">
              <el-input
                :disabled="nameEdit"
                v-model="form.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.port')" prop="port">
              <el-input v-model="form.port" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.fRadius')" prop="radius">
              <el-input v-model="form.radius" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="同时在线" prop="online">
              <el-input v-model="form.online" autocomplete="off"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <div class="btns">
          <el-button
            @click="confirm"
            type="primary"
            size="small"
            style="width: 100%"
            >{{ $t("public.submit") }}</el-button
          >
          <el-button @click="handleClose" size="small" style="width: 100%">{{
            $t("public.cancel")
          }}</el-button>
        </div>
      </div>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from "../../../components/public/customDialog";
import { addStation, updateStation } from "@/api/index.js";
export default {
  name: "OverseasStationManageViewList",
  components: {
    CustomDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "view",
    },
  },
  data() {
    let checkIPPort = (rule, value, callback) => {
      let t =
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?::([1-9]\d{0,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-3]\d|6553[0-5]))?$/;
      // /^(((25[0-5]|2[0-4]d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))))\:([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{4}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;

      if (!value) {
        callback(new Error(this.$t('public.ver11')));
      } else if (!t.test(value)) {
        callback(new Error(this.$t('public.ver6')));
      } else {
        callback();
      }
    };
    return {
      nameEdit: true,
      form: {
        name: "",
        port: "",
        radius: "",
        // online: "",
      },
      rules: {
        name: [
          { required: true, message: this.$t('public.ver13'), trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        radius: [
          { required: true, message: this.$t('public.ver10'), trigger: "blur" },
          // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        port: [
          { required: true, message: this.$t('public.ver11'), trigger: "blur" },
          { validator: checkIPPort, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    rowInfo: {
      handler(newV, oldV) {
        // console.log(newV, "eeee");
      },
    },
    show: {
      handler(newV, oldV) {
        if (newV) {
          if (Object.keys(this.rowInfo).length) {
            this.nameEdit = true;
            this.form.port = this.rowInfo.ip;
            this.form.name = this.rowInfo.nm;
            this.form.radius = this.rowInfo.radius;
            this.form.id = this.rowInfo.id;
          } else {
            this.nameEdit = false;
          }
        }
      },
    },
  },
  mounted() {},

  methods: {
    confirm() {
      let params = {
        sta: this.form.name,
        ipport: this.form.port,
        radius: Number(this.form.radius)
      };

      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.nameEdit) {
            addStation(params).then((res) => {
              if (res.code == 200) {
                this.handleClose();
                this.$emit("refush");
                this.$message.success(this.$t("public.success2"));
              }
            });
          } else {
            updateStation(params).then((res) => {
              if (res.code == 200) {
                this.handleClose();
                this.$emit("refush");
                this.$message.success(this.$t("public.success1"));
              }
            });
          }

          this.$emit("update:show", false);
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
      // this.$message.warning(this.$t("public.p8"))
      // console.log("确定");
    },
    handleClose() {
      this.form = {
        port: "",
        name: "",
        radius: ""
      };
      this.$refs.ruleForm.resetFields();
      this.$refs.ruleForm.clearValidate();
      this.$emit("update:show", false);
      this.$emit("update:rowInfo", {});
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
